"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorF = void 0;
var tslib_1 = require("tslib");
var analyticsEventBase_1 = require("./../sdks/firebase/analyticsEventBase");
var effects_1 = require("redux-saga/effects");
var actions_1 = require("../constants/actions");
var statusCodes_1 = require("../constants/statusCodes");
var browser_1 = require("@sentry/browser");
var sentrySdk_1 = require("../sdks/sentry/sentrySdk");
var SentrySeverity_1 = require("../sdks/sentry/SentrySeverity");
var errorF = function () {
    var action, error, reponseMessage, responseStatus, message, fallbackStatus, status_1, hasMessage;
    var _a, _b, _c;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!1) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.take)(actions_1.ERROR)];
            case 1:
                action = _d.sent();
                error = action.error;
                reponseMessage = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
                responseStatus = (_c = error.response) === null || _c === void 0 ? void 0 : _c.status;
                message = reponseMessage || error.message || 'Javascript Error';
                fallbackStatus = error.message === 'Network Error'
                    ? statusCodes_1.statusCodes.networkError
                    : statusCodes_1.statusCodes.javascriptError;
                status_1 = responseStatus || fallbackStatus;
                hasMessage = status_1 === statusCodes_1.statusCodes.unprocessable && message;
                (0, analyticsEventBase_1.analyticsEventBase)({ event: 'Error' });
                (0, browser_1.captureException)(error);
                (0, sentrySdk_1.sentrySdk)().captureMessage("ERROR: ".concat(action.description), SentrySeverity_1.SentrySeverity.Critical);
                if (!!hasMessage) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'SET_ALERT_MESSAGE',
                        description: 'errorF',
                        values: {
                            location: 'modal',
                            actionType: action.type,
                            type: 'error',
                            message: message,
                            description: action.description,
                        },
                    })];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3: return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.errorF = errorF;
